<template>
  <div class="sms-list-container">
    <b-overlay
      :show="overlay_show"
      rounded="sm"
      :variant="overlay_variant"
      opacity="0.5"
      blur="2px"
    >
      <b-card>
        <b-row class="mb-3">
          <!-- <b-col lg="3"
            ><v-select
              :class="select_filter_class + ' select-filter'"
              :options="categories"
              :clearable="false"
              name="category"
              title="category"
              v-model="category"
              :reduce="(item) => item.code"
              placeholder="Select category"
              required
              @input="changeCategoryFilter"
            ></v-select
          ></b-col> -->
          <b-col lg="3" md="3" sm="6"
            ><v-select
              :class="select_filter_class + ' select-filter'"
              :options="smsStatus"
              :clearable="false"
              name="sms_status"
              title="sms_status"
              v-model="sms_status"
              :reduce="(item) => item.code"
              placeholder="Select  status"
              required
              @input="changeStatusFilter"
            ></v-select
          ></b-col>

          <b-col lg="3" md="3" sm="6" offset-lg="6" offset-md="6">
            <b-button
              variant="doomyoga-primary"
              id=""
              class="btn btn-filter m-0 btn-doomyoga float-right"
                            v-b-modal.addSMSModal

            >
              + Add New
            </b-button>

          </b-col>
        </b-row>
        <b-table-simple
          :class="'table table-no-bordered table-hover ' + table_class"
          id="smsTable"
          hover
          responsive
        >
          <b-thead>
            <b-tr>
              <b-th>Date & Time</b-th>
              <!-- <b-th>Category</b-th> -->
              <b-th class="text-center">Status</b-th>
              <b-th class="text-center">Previously Sent </b-th>
              <b-th class="text-center">SMS Fees</b-th>
              <b-th class="text-center">Actions</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="item in rowsData" :key="item.id">
              <b-td>{{ item.date }}</b-td>
              <!-- <b-td>{{ item.category }}</b-td> -->
              <b-td
                ><span
                  class="dataStatusSpan"
                  v-bind:class="{
                    smsSentStatus: item.status == 'Sent',
                    smsNotSentStatus: item.status == 'Not sent',
                  }"
                >
                  {{ item.status }}
                </span></b-td
              >
              <b-td class="text-center">{{ item.previously_sent }}</b-td>
              <b-td class="text-center">{{ currency }}{{ item.sms_fees }}</b-td>

              <b-td class="text-center">
                <b-button
                  variant="action"
                  class="mb-1"
                  @click="viewSMS(item.id)"
                  ><img
                    :src="require('@/assets/images/' + view_img_path)"
                    alt="view icon" /></b-button
              ></b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-card>
    </b-overlay>
    <AddSmsModal />
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import AddSmsModal from "./AddSmsModal.vue";

import Vue from "vue";
import vSelect from "vue-select";
Vue.component("v-select", vSelect);

export default {
  name: "SMSList",
  components: {AddSmsModal},
  props: [
    "client_name",
    "table_class",
    "overlay_variant",
    "select_filter_class",
    "view_img_path",
    "currency",
  ],
  data() {
    return {
      customers: [],
      table: null,
      overlay_show: false,
      categories: [{ label: "All categories", code: "" }],
      category: "",
      smsStatus: [{ label: "All statuses", code: "" }],
      sms_status: "",

      rowsData: [],
    };
  },
  mounted() {
    // let user = JSON.parse(window.localStorage.getItem("user"));
    // console.log(user);
    // console.log(user.id, user.title);
    // this.user_id = user.id;
    // this.user_title = user.type;
    // // this.getOrders(user.id);
    // console.log(this.user_title);
    // console.log(this.user_title);
    this.overlay_show = true;
    let temp = this;
    temp.getSmsList();
  },
  methods: {
    getSmsList() {
      console.log("here call SMS list");
      // console.log(JSON.parse(window.localStorage.getItem("user")).access_token);
      this.rowsData = [
        {
          id: 1,
          date: "20 June 2020, 12:30 pm ",
          category: "Promotion",
          status: "Sent",
          previously_sent: 2,
          sms_fees: "20",
        },
        {
          id: 2,
          date: "20 June 2020, 12:30 pm ",
          category: "Upcoming event",
          status: "Not sent",
          previously_sent: 2,
          sms_fees: "20",
        },
      ];
      var temp = this;
      setTimeout(function () {
        temp.initTable();
      }, 1000);
      temp.overlay_show = false;

      return;

      axios
        .get("/admin/users", {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: "DY",
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          if (this.table != null) {
            this.table.destroy();
          }
          console.log(response);
          this.customers = response.data;
          var temp = this;
          setTimeout(function () {
            temp.initTable();
          }, 1000);
          temp.overlay_show = false;
        });
    },
    initTable() {
      let temp = this;
      this.table = $("#smsTable").DataTable({
        ordering: false,
        info: true,
        destroy: true,
        responsive: true,
        // scrollY: "450px",
        scrollCollapse: true,
        searching: true,
        lengthMenu: [
          [5, 10, 25, 50, 100],
          [5, 10, 25, 50, 100],
        ],
        columnDefs: [
          {
            targets: -1,
            orderable: false,
          },
          {
            targets: 1,
            render: function (data, type, full, meta) {
              console.log("render");
              console.log(data);
              console.log(type);
              console.log(full);
              console.log(meta);
              if (type === "filter") {
                return $("#smsTable")
                  .DataTable()
                  .cell(meta.row, meta.col)
                  .nodes()
                  .to$()
                  .find(".dataStatusSpan")
                  .text();
              } else {
                return data;
              }
            },
          },
        ],
        search: {
          regex: true,
        },
        pagingType: "full_numbers",
        language: {
          paginate: {
            previous: "<i class='fas fa-angle-left'></i>",
            next: "<i class='fas fa-angle-right'></i>",
            first: "<i class='fas fa-angle-double-left'></i>",
            last: "<i class='fas fa-angle-double-right'></i>",
          },
          search: "",
          searchPlaceholder: "Search ",
        },
        initComplete: function () {
          // var column = this.api().column(1);
          // column
          //   .data()
          //   .unique()
          //   .sort()
          //   .each(function (d, j) {
          //     console.log(d);
          //     console.log(j);
          //     //   select.append('<option value="' + d + '">' + d + "</option>");
          //     console.log(temp.categories);
          //     temp.categories.push({ label: d, code: d });
          //   });
          var column2 = this.api().column(1);
          column2
            .data()
            .unique()
            .sort()
            .each(function (d, j) {
              // console.log(d);
              // console.log(j);
              // console.log($(d).html());
              // console.log($(d).text());
              let val = $(d).text();
              const val2 = (val.charAt(0).toUpperCase() + val.slice(1)).trim();

              //   select.append('<option value="' + d + '">' + d + "</option>");
              // console.log(temp.smsStatus, val2);
              temp.smsStatus.push({ label: val2, code: val2 });
            });
        },
      });
      $.fn.dataTable.ext.search.push(function (settings, data, dataIndex) {
        console.log(data);
        console.log(data[1].trim());
        var val = data[1].trim(); // use data for the age column
        console.log(val, temp.sms_status);

        if (temp.sms_status === val || temp.sms_status == "") {
          return true;
        }
        return false;
      });
    },
    // changeCategoryFilter() {
    //   console.log(this.category);
    //   this.table.column(1).search(this.category).draw();
    // },
    changeStatusFilter() {
      console.log("--" + this.sms_status.toUpperCase().trim() + "--");
      // var val = $.fn.dataTable.util.escapeRegex(this.sms_status.toUpperCase().trim());
      // console.log(val)
      // this.table.columns(2).search((val ? '^' + val + '$' : ''), true, true).draw();

      // this.table
      //   .column(2)
      //   .search(
      //     this.sms_status.toUpperCase().trim(),
      //     true,
      //     false
      //   )
      //   .draw();
      this.table.draw();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/SMS/List.vue